import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Icon} from "semantic-ui-react";
import {Tooltip} from "antd";
import Offline from "../../views/Reception/Dashboard/Offline/Offline";
import Inquiries from "../../views/Reception/Dashboard/Inquiries/Inquiries";
import '../Reception/Style.css';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  state = {
    isOffline: false,
    isInquiries: false,
  };

  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        {
          this.state.isOffline ?
            <Offline closeModal={()=>this.setState({isOffline: false})}/>:null


        }
        {
          this.state.isInquiries ?
            <Inquiries closeModal={()=>this.setState({isInquiries: false})}/>:null
        }

        <span >
          <Tooltip placement="topLeft" title="Offline access">
          <button className={"offline-btn"} onClick={()=>this.setState({isOffline:true})}>Offline Access &nbsp;
            <Icon name={"hard of hearing"}/>
          </button>
        </Tooltip>

        <Tooltip placement="topLeft" title="User inquiries">
          <button style={{marginLeft: '15px'}} className={"inquiries-btn"} onClick={()=>this.setState({isInquiries:true})}>User inquiries &nbsp;
            <Icon name={"write square"}/>
          </button>
        </Tooltip>

        </span>
        <span className="ml-auto" ><a>Miracle Dome</a> &copy; 2024</span>
        <span className="ml-auto" style={{fontSize:'13px'}}>Solution partner <a target="_blank" href={"https://business.dialog.lk/"} style={{textDecoration:'none',color:'#1f1f1f!important'}}>Dialog Enterprise</a></span>
      </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
